<template>
  <section class="w-full">
    <label class="text-xl font-medium pb-16px" v-if="label" v-text="label"/>
    <input
      type="date"
      class="bg-skin-check_inactive focus:outline-none w-full text-skin-check-box placeholder-opacity-80 rounded-xl px-12px py-2.5 text-base flex justify-between items-center"
      @input="onInputValue"
    />
    <p v-if="isThereError" class="text-xs pr-2 pt-2 text-red-500 text-left" v-text="errorMessage"/>
  </section>
</template>
<script>
export default {
  data: () => ({
    error: false,
  }),
  methods: {
    validate() {
      if (this.value === null) {
        this.error = true;
        return true;
      }
      return false;
    },
    onInputValue(e) {
      this.$emit("input", e.target.value);
    },
  },
  props: {
    value: {
      default: null,
    },
    placeholder: {
      default: "",
    },
    identity: {
      default: null,
    },
    label:{
      default: null
    }
  },
  computed: {
    errorMessage() {
      if (this.value === null) return `El campo ${this.identity} es requerido`;
      return "";
    },
    isThereError() {
      if (this.error) return this.value === null;
      return false;
    },
  },
};
</script>
